import { z } from 'zod';

// Page schemas
export const pageSchema = z.object({
  id: z.string().uuid(),
  siteId: z.string().uuid(),
  title: z.string().min(1, 'Page title is required'),
  slug: z.string().min(1, 'Page slug is required'),
  components: z.string().nullable(),
  orderPosition: z.number().optional(),
  isHomePage: z.boolean().optional(),
  noindex: z.boolean().optional(), // Whether to exclude from search engine indexing (default: false = indexed)
  layoutId: z.string().uuid().nullable().optional(), // Reference to page layout
  showLayout: z.boolean().optional().default(true), // Whether to show the layout for this page
  publishedComponents: z.string().nullable().optional(), // Snapshot of components at last publish
  publishedHtml: z.string().nullable().optional(), // Pre-rendered HTML for live site
  publishedAt: z.string().datetime().nullable().optional(), // Timestamp of last publish
  widgetManifest: z.string().nullable().optional(), // JSON manifest of required widget scripts
  publishedSlug: z.string().nullable().optional(), // Slug at time of last publish
  publishedHash: z.string().nullable().optional(), // SHA-256 hash for idempotent publish detection
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const createPageRequestSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  slug: z.string().min(1, 'Slug is required'),
  orderPosition: z.number().optional(),
  isHomePage: z.boolean().optional(),
  noindex: z.boolean().optional(), // Whether to exclude from search engine indexing
});

export const updatePageRequestSchema = z.object({
  title: z.string().optional(),
  slug: z.string().optional(),
  components: z.string().optional(),
  orderPosition: z.number().optional(),
  isHomePage: z.boolean().optional(),
  noindex: z.boolean().optional(), // Whether to exclude from search engine indexing
  layoutId: z.string().uuid().nullable().optional(), // Reference to page layout
  showLayout: z.boolean().optional(), // Whether to show the layout for this page
});

// Type exports
export type Page = z.infer<typeof pageSchema>;
export type CreatePageRequest = z.infer<typeof createPageRequestSchema>;
export type UpdatePageRequest = z.infer<typeof updatePageRequestSchema>;
